import { Controller } from "@hotwired/stimulus"

const SILENT_RETRIES = 2
const RETRY_DELAY_MS = 1500

export default class extends Controller {
  static targets = ['content', 'image', 'fallback', 'frame']
  static values = { refreshUrl: String }

  show() {
    const fragment = document.createRange().createContextualFragment(this.contentTarget.innerHTML)
    const overlay = fragment.firstElementChild
    overlay.addEventListener('click', () => overlay.remove())
    document.body.appendChild(overlay)
  }

  failed() {
    if ((this.attempts || 0) < SILENT_RETRIES) return this.retryLater()

    this.showFallback()
  }

  async retry(event) {
    event?.stopPropagation()
    this.attempts = (this.attempts || 0) + 1

    const source = this.attempts === 1 ? this.bustedSource() : await this.freshSource()
    if (!source) return this.showFallback()

    if (this.hasFallbackTarget) this.fallbackTarget.classList.replace('flex', 'hidden')
    this.frameTarget.classList.remove('hidden')
    this.imageTarget.src = source
  }

  retryLater() {
    const delay = RETRY_DELAY_MS * ((this.attempts || 0) + 1)
    setTimeout(() => this.retry(), delay)
  }

  showFallback() {
    if (!this.hasFallbackTarget) return

    this.fallbackTarget.classList.replace('hidden', 'flex')
    this.frameTarget.classList.add('hidden')
  }

  bustedSource() {
    const url = new URL(this.imageTarget.src, window.location.origin)
    url.searchParams.set('retry', Date.now())
    return url.toString()
  }

  async freshSource() {
    if (!this.hasRefreshUrlValue) return null

    try {
      const response = await fetch(this.refreshUrlValue, { headers: { Accept: 'application/json' } })
      if (!response.ok) return null

      const { url } = await response.json()
      return url
    } catch {
      return null
    }
  }
}
